import { useIntl } from "react-intl"

export function useIntlSort(): { localeComparator: (x: string, y: string) => number } {
  const intl = useIntl()
  return {
    localeComparator: new Intl.Collator(intl.locale).compare
  }
}
